import CutStep from '/components/products/pack-builder/one-flow/CutStep';
import Footer from '/components/products/pack-builder/one-flow/Footer';
import PackSizeStep from '/components/products/pack-builder/one-flow/PackSizeStep';
import ProductStep from '/components/products/pack-builder/one-flow/ProductStep';
import PropTypes from 'prop-types';
import SizeStep from '/components/products/pack-builder/one-flow/SizeStep';
import StepNavigation from '/components/products/pack-builder/one-flow/StepNavigation';
import { Wizard } from 'react-use-wizard';
import { getStatSigTestVariant } from '/services/ab-test';
import { BUILD_A_PACK_DATA, getPackBuilderData } from '/services/static/packs/build-a-pack';
import { useEffect, useState } from 'react';

const PackBuilderFlow = ({ packType, parentProduct }) => {
	const [builderConfig, setBuilderConfig] = useState({});
	const [showPackSizeStep, setShowPackSizeStep] = useState(false);

	const defaultProductTypes = {
		mens: 'Boxers',
		socks: 'Socks - Crew',
		womens: 'Cheeky',
	};

	const [activeProductType, setActiveProductType] = useState(defaultProductTypes[packType]);
	const [packConfig, setPackConfig] = useState({
		currentProductConfigIndex: 0,
		packSize: null,
		productConfigs: [],
		selectedExtras: [],
		selectedProducts: [],
	});
	const [status, setStatus] = useState({ error: false });

	useEffect(() => {
		if (!BUILD_A_PACK_DATA[packType]) {
			setStatus({ error: true, message: 'No builder config' });
			return;
		}

		const config = getPackBuilderData(packType);
		setBuilderConfig(config);

		if (config.isSpecialPack && config.box) {
			setShowPackSizeStep(false);
			return;
		}

		const checkVariant = async () => {
			const variant = await getStatSigTestVariant('pack_builder_-_fixed_pack_sizes');
			setShowPackSizeStep(variant === 'show-buckets');
		};
		checkVariant();
	}, [packType]);

	const updatePackConfig = (key, value) => {
		const toUpdate = { ...packConfig };
		toUpdate[key] = value;
		setPackConfig(toUpdate);
	};

	const updatePackProductConfig = (index, key, value) => {
		const toUpdate = { ...(packConfig?.productConfigs?.[index] || {}) };
		toUpdate[key] = value;

		const updatedPackConfig = { ...packConfig };
		packConfig.productConfigs[index] = toUpdate;
		setPackConfig(updatedPackConfig);
	};

	if (status.error === true) {
		return <div>{status.message}</div>;
	}
	const packSizeOptions = [
		{
			title: '3 Pack',
			quantity: 3,
			discount: 0.1,
		},
		{
			title: '5 Pack',
			quantity: 5,
			discount: 0.2,
		},
		{
			title: '7 Pack',
			quantity: 7,
			discount: 0.3,
		},
	];

	return (
		<div>
			<div className="relative max-w-7xl min-h-[800px] m-auto pb-6">
				<Wizard
					onStepChange={() => {
						window.scrollTo(0, 0);
					}}
					footer={
						<Footer
							activeProductType={activeProductType}
							parentProductId={builderConfig.reviewsProduct}
						/>
					}
					header={
						<StepNavigation
							builderConfig={builderConfig}
							packConfig={packConfig}
							updatePackConfig={updatePackConfig}
						/>
					}>
					{showPackSizeStep && (
						<PackSizeStep
							builderConfig={builderConfig}
							packConfig={packConfig}
							packSizeOptions={packSizeOptions}
							updatePackConfig={updatePackConfig}
							updatePackProductConfig={updatePackProductConfig}
						/>
					)}
					<CutStep
						builderConfig={builderConfig}
						packConfig={packConfig}
						updatePackConfig={updatePackConfig}
						updatePackProductConfig={updatePackProductConfig}
						setActiveProductType={setActiveProductType}
					/>
					<SizeStep
						builderConfig={builderConfig}
						packConfig={packConfig}
						updatePackConfig={updatePackConfig}
						updatePackProductConfig={updatePackProductConfig}
					/>
					<ProductStep
						builderConfig={builderConfig}
						packConfig={packConfig}
						parentProduct={parentProduct}
						packSizeOptions={packSizeOptions}
						updatePackConfig={updatePackConfig}
						setActiveProductType={setActiveProductType}
					/>
				</Wizard>
			</div>
		</div>
	);
};

PackBuilderFlow.propTypes = {
	packType: PropTypes.string,
	parentProduct: PropTypes.object,
};

export default PackBuilderFlow;
